/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidationTokenModel } from '../../models/validation-token-model';

export interface GetValidationToken$Json$Params {

/**
 * id of validationtoken for filter
 */
  validationTokenId: string;
}

export function getValidationToken$Json(http: HttpClient, rootUrl: string, params: GetValidationToken$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidationTokenModel>> {
  const rb = new RequestBuilder(rootUrl, getValidationToken$Json.PATH, 'get');
  if (params) {
    rb.path('validationTokenId', params.validationTokenId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidationTokenModel>;
    })
  );
}

getValidationToken$Json.PATH = '/api/ValidationToken/{validationTokenId}';
